import { render, staticRenderFns } from "./GoodsClaimOutbounce.vue?vue&type=template&id=88921ab4&scoped=true"
import script from "./GoodsClaimOutbounce.vue?vue&type=script&lang=js"
export * from "./GoodsClaimOutbounce.vue?vue&type=script&lang=js"
import style0 from "./GoodsClaimOutbounce.vue?vue&type=style&index=0&id=88921ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88921ab4",
  null
  
)

export default component.exports